import { newArray } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
//import { Settings } from '../app/app.component';
import * as appComponent from '../app/app.component';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  title = 'ConnectFeedback';
  logMessage: string;
  settings: appComponent.Settings;
  feedbackItem: FeedbackItem;

  constructor() {
    console.log("Start FeedbackService constructor");
  }
  async LogFeedback(ContactID: string, CommentText: string, FeedbackScore: number, Page: string, Ordinal: number, settings: appComponent.Settings): Promise<FeedbackItem> {
    this.settings = settings;
    //console.log("In Log Feedback - Settings = " + this.settings);
    console.log("Going to save feebback for ID ", ContactID);
    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + ' ' + time;
    console.log(dateTime)
    let header = new Headers();
    header.append("Accept", "application/json");
    header.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      "ClientID": this.settings.config_ClientID,
      "Score": FeedbackScore,
      "FeedbackDate": dateTime,
      "Comment": CommentText,
      "Ordinal": Ordinal,
      "ID": ContactID,
      "Page": Page
    });
    console.log("Feedback JSON = " + raw);
    var requestOptions: RequestInit = {
      method: 'POST',
      headers: header,
      body: raw,
      redirect: 'follow'
    };
    let URL = "https://connect-fedback.azurewebsites.net/api/LogFeedback?code=jZCnQ0aNFzDZx90pg5cpECFPPf8am7zYiiZaUPNUeS76AzFu2j97Aw==";
    await fetch(URL, requestOptions)
      .then(response => response.json())
      .then(response => {
        console.log("Got Response " + response);
        this.feedbackItem = new FeedbackItem();
        this.feedbackItem.Score = FeedbackScore;
        let RespJson = JSON.parse(response);
        this.feedbackItem.Ordinal = RespJson["Ordinal"];
        console.log("Ordinal " + this.feedbackItem.Ordinal);
      })
      .catch(error => console.log('error', error));
    return this.feedbackItem;
  }


}
export class FeedbackItem {
  Score: number;
  Ordinal: number;
}




